<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class="">Editar Paciente</mat-card-title>
    </div>
    <!--    <button class="btn-icon" (click)="close()">-->
    <!--      <mat-icon>close</mat-icon>-->
    <!--    </button>-->
    <button mat-flat-button class="btn-tg-cancel w-1/12" (click)="close()">
      Cancelar
    </button>
    <button
      mat-flat-button
      class="btn-tg w-1/12"
      [disabled]="checkInvalidForm()"
      (click)="editPatient()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Editar
      }
    </button>
  </mat-card-header>

  <div class="mt-4 mb-2"></div>

  @if (!loadingScreen) {
    <mat-accordion multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="panel-header">
          <mat-panel-title>
            <h4>Paciente</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="mt-4">
          <!--        <mat-form-field class="input-tg w-1/5" appearance="outline">-->
          <!--          <mat-label>Tipo Cliente</mat-label>-->
          <!--          <mat-select [(value)]="typeClient">-->
          <!--            @for (type of listTypeClient; track type) {-->
          <!--              <mat-option [value]="type.id">{{ type.description }}</mat-option>-->
          <!--            }-->
          <!--          </mat-select>-->
          <!--        </mat-form-field>-->
          <div [formGroup]="formLegalEntity">
            <div class="flex justify-between gap-4 items-center">
              <mat-form-field class="input-tg w-6/12" appearance="outline">
                <mat-label>Nome</mat-label>
                <input matInput formControlName="name" />
              </mat-form-field>

              <mat-form-field class="input-tg w-2/12" appearance="outline">
                <mat-label>CPF</mat-label>
                <input matInput formControlName="cpf" [mask]="'999.999.999-99'" />
              </mat-form-field>
              <mat-form-field class="input-tg w-2/12" appearance="outline">
                <mat-label>Município</mat-label>
                <mat-select formControlName="municipality" (selectionChange)="onMunicipioChange()">
                  @for (type of listaMunicipios; track type) {
                    <mat-option [value]="type.id">{{ type.nome }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="input-tg w-2/12" appearance="outline">
                <mat-label>Unidade de Saúde</mat-label>
                <mat-select formControlName="healthUnit">
                  @for (type of listaUnidades; track type) {
                    <mat-option [value]="type.id">{{ type.nome }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flex justify-between gap-4 items-center">
              <mat-form-field class="input-tg mt-message-input w-3/12" appearance="outline">
                <mat-label>Email - Login</mat-label>
                <input matInput formControlName="email" />
              </mat-form-field>

              <mat-form-field class="input-tg mt-message-input w-3/12" appearance="outline">
                <mat-label>Senha - Login</mat-label>
                <input matInput formControlName="password" />
              </mat-form-field>
              <mat-form-field class="input-tg mt-message-input w-3/12" appearance="outline">
                <mat-label>Telefone</mat-label>
                <input matInput formControlName="phone" [mask]="'(99) 99999-9999'" />
              </mat-form-field>

              <mat-form-field class="input-tg mt-message-input w-3/12" appearance="outline">
                <mat-label>Data nascimento</mat-label>
                <input
                  matInput
                  [matDatepicker]="birth"
                  (focus)="openDatepicker()"
                  formControlName="birth"
                />
                <mat-datepicker-toggle matIconSuffix [for]="birth"></mat-datepicker-toggle>
                <mat-datepicker #birth></mat-datepicker>
              </mat-form-field>

            </div>
            <div class="flex justify-between gap-4 items-center">
              <mat-form-field class="input-tg mt-message-input w-3/12" appearance="outline">
                <mat-label>Estado Civil</mat-label>
                <mat-select formControlName="maritalStatus">
                  @for (type of [
                    { id: 1, descricao: "Solteiro(a)" },
                    { id: 2, descricao: "Casado(a)" },
                    { id: 3, descricao: "Divorciado(a)" },
                    { id: 4, descricao: "Viúvo(a)" },
                    { id: 5, descricao: "Separado(a)" },
                    { id: 6, descricao: "União Estável" }
                  ]; track type) {
                    <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field class="input-tg mt-message-input w-3/12" appearance="outline">
                <mat-label>RG</mat-label>
                <input matInput formControlName="rg" />
              </mat-form-field>
              <mat-form-field class="input-tg mt-message-input w-3/12" appearance="outline">
                <mat-label>Gênero</mat-label>
                <mat-select formControlName="sex">
                  @for (type of [{id: 'M', descricao: "Masculino"},{id: "F", descricao: "Feminino"}]; track type) {
                    <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <div class="input-tg mt-message-input w-3/12 align-center justify-center flex items-center">
                <mat-checkbox formControlName="consentForm">
                  Paciente concorda com os termos e condições?
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header class="panel-header">
          <mat-panel-title>
            <h4>Dados de Saúde</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="mt-4">
          <!--        <mat-form-field class="input-tg w-1/5" appearance="outline">-->
          <!--          <mat-label>Tipo Cliente</mat-label>-->
          <!--          <mat-select [(value)]="typeClient">-->
          <!--            @for (type of listTypeClient; track type) {-->
          <!--              <mat-option [value]="type.id">{{ type.description }}</mat-option>-->
          <!--            }-->
          <!--          </mat-select>-->
          <!--        </mat-form-field>-->
          <div [formGroup]="healthForm">
            <div class="flex justify-between gap-4 items-center">
              <mat-form-field class="input-tg w-1/5" appearance="outline">
                <mat-label>Altura</mat-label>
                <input  matInput
                        formControlName="height"
                        decimalInput=","
                        inputMode="numeric"
                />
                <span matSuffix>m &nbsp;</span>
              </mat-form-field>

              <mat-form-field class="input-tg w-1/5" appearance="outline">
                <mat-label>Peso</mat-label>
                <input matInput formControlName="weight"
                       decimalInput=","
                       inputMode="numeric"
                />
                <span matSuffix>kg &nbsp;</span>
              </mat-form-field>
              <mat-form-field class="input-tg w-1/5" appearance="outline">
                <mat-label>Hábitos</mat-label>
                <mat-select multiple formControlName="habits">
                  @for (type of listaHabitos; track type) {
                    <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="input-tg w-1/5" appearance="outline">
                <mat-label>Doenças Prévias</mat-label>
                <mat-select multiple formControlName="previousDiseases">
                  @for (type of listaDoencas; track type) {
                    <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="input-tg w-3/12" appearance="outline">
                <mat-label>Histórico</mat-label>
                <textarea matInput [placeholder]="'Paciente possui diabetes há 2 anos...'" formControlName="history"></textarea>
              </mat-form-field>
            </div>
            <div>
              <medical-insurance-patient-edit [idPatient]="this.data.item.paciente_id" [data]="this.data.item.convenios" />
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Endereço</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <address-patient-edit [idPerson]="this.data.item.pessoaId" [address]="addressClient" />
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Contatos de emergência</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <contact-patient-edit [idPerson]="this.data.item.paciente_id" />
        </div>
      </mat-expansion-panel>



      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Exame - Paramêtros</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <exam-patient-edit
            [idPatient]="this.data.item.paciente_id"
          ></exam-patient-edit>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Lembretes</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <alert-patient-edit [idPatient]="this.data.item.paciente_id" />
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  } @else {
    <div class="m-auto">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  }
</mat-card>
